import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Panel } from "@/components/KpiCard";
import { money, moisLabel } from "@/lib/api";

const axe = { fontSize: 11, fill: "#64748b" };
const ton = (v) => (v < 0 ? "text-red-600" : "text-emerald-700");

const Tableau = ({ rows }) => {
  const tot = rows.reduce((a, r) => ({ revenus: a.revenus + r.revenus, depenses: a.depenses + r.depenses, solde: a.solde + r.solde }), { revenus: 0, depenses: 0, solde: 0 });
  const th = "py-2 px-1 sm:px-2 text-[10px] sm:text-[11px] font-mono uppercase tracking-wider text-slate-500";
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs sm:text-sm" data-testid="solde-mensuel-table">
        <thead><tr><th className={`${th} text-left`}>Mois</th><th className={`${th} text-right`}>Revenus</th><th className={`${th} text-right`}>Dépenses</th><th className={`${th} text-right sticky right-0 bg-white`}>Solde</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.mois} className="border-t border-slate-100" data-testid={`solde-row-${r.mois}`}>
              <td className="py-1.5 px-1 sm:px-2 whitespace-nowrap">{moisLabel(r.mois)}</td>
              <td className="py-1.5 px-1 sm:px-2 text-right tabular">{money(r.revenus)}</td>
              <td className="py-1.5 px-1 sm:px-2 text-right tabular">{money(r.depenses)}</td>
              <td className={`py-1.5 px-1 sm:px-2 text-right tabular font-semibold sticky right-0 bg-white ${ton(r.solde)}`} data-testid={`solde-${r.mois}`}>{money(r.solde)}</td>
            </tr>
          ))}
          <tr className="border-t border-slate-200 bg-slate-50 font-semibold" data-testid="solde-row-total">
            <td className="py-2 px-1 sm:px-2">Total</td><td className="py-2 px-1 sm:px-2 text-right tabular">{money(tot.revenus)}</td>
            <td className="py-2 px-1 sm:px-2 text-right tabular">{money(tot.depenses)}</td><td className={`py-2 px-1 sm:px-2 text-right tabular sticky right-0 bg-slate-50 ${ton(tot.solde)}`} data-testid="solde-total">{money(tot.solde)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const SoldeMensuelPanel = ({ rows }) => (
  <Panel title="Solde du mois (revenus − dépenses Desjardins)" testId="solde-mensuel">
    {!rows.length ? <p className="text-sm text-slate-500">Aucune opération.</p> : (
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_420px] gap-6 items-start">
        <div className="h-72" data-testid="solde-mensuel-chart">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={rows.map((r) => ({ ...r, label: moisLabel(r.mois) }))} margin={{ top: 5, right: 10, left: 10, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
              <XAxis dataKey="label" tick={axe} />
              <YAxis tick={axe} tickFormatter={(v) => `${Math.round(v / 1000)} k$`} width={52} />
              <Tooltip formatter={(v) => money(v)} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="revenus" name="Revenus" fill="#047857" radius={[3, 3, 0, 0]} />
              <Bar dataKey="depenses" name="Dépenses" fill="#94a3b8" radius={[3, 3, 0, 0]} />
              <Line type="monotone" dataKey="solde" name="Solde" stroke="#0f172a" strokeWidth={2}
                dot={({ cx, cy, payload }) => <circle key={payload.mois} cx={cx} cy={cy} r={4} fill={payload.solde < 0 ? "#dc2626" : "#047857"} stroke="#fff" strokeWidth={1.5} />} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
        <Tableau rows={rows} />
      </div>
    )}
  </Panel>
);
